import front from "../../assets/front.jpg";
import tools from "../../assets/tools.jpg";
import methodology from "../../assets/methodology.jpg";
import services from "../../assets/services.jpg";
import blog from "../../assets/blog.jpeg";
import about from "../../assets/about.jpg";
import bottom from "../../assets/bottom.mp4";
import frontSummer from "../../assets/front_summer.jpg";
import toolsSummer from "../../assets/tools_summer.jpg";
import methodologySummer from "../../assets/methodology_summer.jpg";
import servicesSummer from "../../assets/services_summer.jpg";
import blogSummer from "../../assets/blog_summer.jpg";
import aboutSummer from "../../assets/about_summer.jpg";
import bottomSummer from "../../assets/bottom_summer.mp4";
import frontWinter from "../../assets/front_winter.jpg";
import toolsWinter from "../../assets/tools_winter.jpg";
import methodologyWinter from "../../assets/methodology_winter.jpg";
import serviceWinter from "../../assets/services_winter.jpg";
import blogWinter from "../../assets/blog_winter.jpg";
import aboutWinter from "../../assets/about_winter.jpg";
import bottomWinter from "../../assets/bottom_winter.mp4";
import moment from "moment";

const today = moment()
const startWinterEnd = moment('11-01', 'MM-DD')
const endWinterEnd = moment('12-31', 'MM-DD')

const startWinterStart = moment('01-01', 'MM-DD')
const endWinterStart = moment('01-31', 'MM-DD')

const startSummer = moment('07-01', 'MM-DD')
const endSummmer = moment('10-30', 'MM-DD')

const isWinterEnd = today.isSameOrAfter(startWinterEnd) && today.isSameOrBefore(endWinterEnd)
const isWinterStart = today.isSameOrAfter(startWinterStart) && today.isSameOrBefore(endWinterStart)

const isSummer = today.isSameOrAfter(startSummer) && today.isSameOrBefore(endSummmer)
const isWinter = isWinterEnd || isWinterStart

const defaultImages = {
    front,
    tools,
    methodology,
    services,
    blog,
    about,
    bottom
}

const winterImages = {
    front: frontWinter,
    tools: toolsWinter,
    methodology: methodologyWinter,
    services: serviceWinter,
    blog: blogWinter,
    about: aboutWinter,
    bottom: bottomWinter
}

const summerImages = {
    front: frontSummer,
    tools: toolsSummer,
    methodology: methodologySummer,
    services: servicesSummer,
    blog: blogSummer,
    about: aboutSummer,
    bottom: bottomSummer
}
export const getBackgroundImage = (page) => {
    if (isWinter) {
        return winterImages[page]
    }

    if (isSummer) {
        return summerImages[page]
    }

    return defaultImages[page]
}


// WEBPACK FOOTER //
// ./src/infrastructure/helpers/getBackgroundImage.js